export const eventsData = [
  {
    id: 1,
    title: "Nan Forum",
    description: "เครือข่ายจุฬาฝ่าพิบัติ Chula DSN ชวนจับมือฝ่าพิบัติ ณ เรือนจุฬานฤมิต จุฬาลงกรณ์มหาวิทยาลัย",
    event_date: "2025-09-11",
    location: "เรือนจุฬานฤมิต จุฬาลงกรณ์มหาวิทยาลัย",
    category: "เทศกาล",
    organizer: "Chula Disaster Studies Network",
    contact_email: "chuladisaster@chula.ac.th",
    contact_phone: "02-218-6789",
    max_participants: 100,
    current_participants: 45,
    registration_deadline: "2025-09-08",
    status: "active",
    created_at: "2025-08-15T08:00:00Z",
    updated_at: "2025-09-01T10:30:00Z",
    date: "2025-09-11", // Keeping for compatibility
    isRecommended: true
  },
]
